module.exports = __webpack_public_path__ + "img/diamond_contractor.e7b323f0.png";